import { render, staticRenderFns } from "./Divider.vue?vue&type=template&id=0b0d01f7&scoped=true"
var script = {}
import style0 from "./Divider.vue?vue&type=style&index=0&id=0b0d01f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0d01f7",
  null
  
)

export default component.exports